import styled from "styled-components/macro"
import { NavLink } from "react-router-dom"

const TAB_WIDTH = "2.3rem"

export const Root = styled.div`
  display: flex;
`

export const Tabs = styled.div`
  position: fixed;
  display: flex;
  flex-direction: row;
  z-index: 999;
  transform: translate(0px, -${TAB_WIDTH}) rotate(90deg);
  transform-origin: bottom left;
`

export const Tab = styled(NavLink)`
  display: inline-flex;
  justify-content: center;
  margin-left: 1px;
  margin-right: 1px;
  fontfamily: Lora-Regular;
  fontsize: 1.1em;
  background-color: ${({
    theme: {
      palette: {
        turquoise: { mid }
      }
    }
  }) => mid};

  line-height: ${TAB_WIDTH};
  transform: rotate(180deg);
  width: ${({ width }) => `${width}vh`};

  color: ${({
    theme: {
      palette: {
        grey: { almostWhite }
      }
    }
  }) => almostWhite} !important;
  text-transform: uppercase;

  &.active {
    background-color: #361b50;
  }

  &:first-child {
    margin-left: 0;
  }

  &:last-child {
    margin-right: 0;
  }
`

export const Content = styled.section`
  display: flex;
  margin-left: ${TAB_WIDTH};
`
